import React from "react";
import { Navigate } from "react-router-dom";
import ContainerRedirect from "../../../../../pages/lib/page-redirect";

import ContainerFullListComponent from "../../../../../components/container-full/components/list/page";
import ContainerFullAddComponent from "../../../../../components/container-full/components/add/page";
import ContainerFullVideosComponent from "../../../../../components/container-full/components/videos/page";

export const containerFullRoute = [
  {
    path: "list",
    element: <ContainerFullListComponent />,
  },
  {
    path: "add",
    element: <ContainerFullAddComponent />,
  },
  {
    path: "videos",
    element: <ContainerFullVideosComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/container/full/add" />,
  },
  {
    path: "edit/:id",
    element: <ContainerFullAddComponent />,
  },
  {
    path: "",
    element: <ContainerRedirect elroute="/container/full" />,
  },
];
